import { createAsyncThunk } from '@reduxjs/toolkit';
import { getIsHubless } from '../../../reducers/Portal';
import { RequestStatus } from '../../../interface';
import { selectDefaultHomeState } from '../selectors/default-home.selectors';
import { getUserHomeKeyRpc } from 'nav-client-types/NavConfigService-v2/operations';
import { rpcClient } from '../../../utils/API';
import { selectPortalId } from '../../../selectors/portal.selectors';
import { dataFetchingErrorHandler } from '../../../errors/dataFetchingErrorHandler';
const fetchDefaultHomeKey = async portalId => {
  const response = await rpcClient.call(getUserHomeKeyRpc, {
    queryParameters: {
      portalId
    } // The client-type is missing the portalId query parameter
  });
  return response.homeKey;
};
export const getDefaultHomeThunk = createAsyncThunk('getDefaultHome', async (_, {
  rejectWithValue,
  getState
}) => {
  const state = getState();
  const isHubless = getIsHubless(state);
  const portalId = selectPortalId(state);
  if (isHubless || !portalId) {
    return rejectWithValue('Portal ID is required');
  }
  try {
    return await fetchDefaultHomeKey(portalId);
  } catch (error) {
    const requestError = error;
    dataFetchingErrorHandler('Failed to fetch default home')(requestError);
    return rejectWithValue('Failed to fetch default home');
  }
}, {
  condition: (_, {
    getState
  }) => {
    const state = getState();
    const {
      status
    } = selectDefaultHomeState(state);
    return status === RequestStatus.IDLE;
  }
});